import { Controller } from "@hotwired/stimulus"
import { ExaminationPreferenceService } from "../services/examination_preference_service"

// Connects to data-controller="soap-prompt-selector"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.syncFromStorage()
  }

  // LocalStorage / Cookie から選択状態を復元・同期
  syncFromStorage() {
    const storedTemplateId = localStorage.getItem('device_soap_prompt_template_id')
    if (storedTemplateId && this.hasSelectTarget) {
      const optionExists = Array.from(this.selectTarget.options).some(opt => opt.value === storedTemplateId)
      if (optionExists && this.selectTarget.value !== storedTemplateId) {
        this.selectTarget.value = storedTemplateId
        this.saveToCookie(storedTemplateId)
      }
    } else if (this.hasSelectTarget && this.selectTarget.value) {
      // 初期描画の値を端末ストレージにキャッシュ
      localStorage.setItem('device_soap_prompt_template_id', this.selectTarget.value)
      this.saveToCookie(this.selectTarget.value)
    }
  }

  async change() {
    const templateId = this.selectTarget.value

    // 1. 端末のCookieとLocalStorageに即時保存（同一アカウント複数端末の競合を防止）
    this.saveToCookie(templateId)
    localStorage.setItem('device_soap_prompt_template_id', templateId)

    // 2. 画面内の別ターゲット（デスクトップ／モバイルのセレクトボックス）の選択状態を同期
    document.querySelectorAll('[data-soap-prompt-selector-target="select"]').forEach(select => {
      if (select !== this.selectTarget) {
        select.value = templateId
      }
    })

    // 3. 録音コントローラー等の連携用にイベント発火
    document.dispatchEvent(new CustomEvent('soap-prompt-template:changed', { detail: { templateId } }))

    try {
      // 4. サーバー側（DBおよびサーバーサイドCookie）へも保存
      await ExaminationPreferenceService.updateSoapPromptTemplate(templateId)
      console.log('端末のSOAP記録形式を更新しました:', templateId)
    } catch (error) {
      console.error('SOAPプロンプト設定のサーバー保存に失敗しました（端末ローカル設定は保持されています）:', error)
    }
  }

  saveToCookie(templateId) {
    document.cookie = `device_soap_prompt_template_id=${encodeURIComponent(templateId)}; path=/; max-age=31536000; SameSite=Lax`
  }
}
